import { render, staticRenderFns } from "./topics-list.vue?vue&type=template&id=e4237326"
import script from "./topics-list.vue?vue&type=script&lang=js"
export * from "./topics-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports